export const SIZE_ORDER = [
    'RN',
    '0 a 6',
    '0 a 12',
    '0 a 15',
    '1',
    '1 a 3',
    '2',
    '3',
    '3 a 4',
    '3 a 5',
    '4',
    '4 a 8',
    '5',
    '6',
    '6 a 8',
    '6 a 12',
    '7',
    '8',
    '9',
    '9 a 12',
    '10',
    '10 a 12',
    '10 a 15',
    '10 a 16',
    '12',
    '13',
    '13 a 15',
    '13 a 16',
    '14',
    '14 a 15',
    '14 a 17',
    '15',
    '15/16',
    '16',
    '16 a 15',
    '16 a 18',
    '16 a 19',
    '16 a 20',
    '17',
    '17 a 20',
    '17 a 22',
    '17/18',
    '18',
    '18 a 21',
    '18/19',
    '19',
    '19 a 21',
    '19 a 22',
    '19/20',
    '20',
    '20 a 22',
    '20 a 23',
    '20/21',
    '21',
    '21/22',
    '22',
    '22 a 25',
    '22/23',
    '23',
    '23 a 26',
    '23/24',
    '24',
    '24/25',
    '25',
    '25 a 28',
    '25/26',
    '26',
    '26 a 29',
    '26/27',
    '27',
    '27 a 29',
    '27 a 30',
    '27/28',
    '28',
    '28 a 31',
    '28 a 33',
    '28/29',
    '29',
    '29/30',
    '29 ao 33',
    '30',
    '30 a 33',
    '30 ao 34',
    '30/31',
    '31',
    '31 a 34',
    '31/32',
    '32',
    '32/33',
    '33',
    '33 a 36',
    '33 a 37',
    '33/34',
    '33 a 38',
    '33 a 40',
    '34',
    '34 a 36',
    '34 a 37',
    '34 a 38',
    '34 a 39',
    '34/35',
    '35',
    '35 a 38',
    '35 a 40',
    '35/36',
    '36',
    '36 ao 44',
    '36/37',
    '37',
    '37 a 40',
    '37 a 41',
    '37 a 43',
    '37 a 44',
    '37/38',
    '38',
    '38 a 43',
    '38/39',
    '39',
    '39 a 42',
    '39 a 43',
    '39 a 44',
    '39 a 45',
    '39/40',
    '40',
    '40/41',
    '41',
    '41 a 44',
    '41/42',
    '42',
    '42/43',
    '43',
    '43/44',
    '44',
    '45',
    '45/46',
    '46',
    '46 a 52',
    '46/47',
    '48',
    '50',
    '52',
    '54',
    '56',
    '58',
    '60',
    'PP',
    'P',
    'M',
    'G',
    'GG',
    'XG',
    'XGG',
    'XXG',
    'XLG',
    'EXG',
    'EXG1',
    'EX1',
    'EX2',
    'G1',
    'G2',
    'G3',
    'G4',
    'G5',
    'G6',
    'G7',
    'UN',
]
